'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.start = start;

require('babel-polyfill');

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _reactDom = require('react-dom');

require('./assets/prism.css');

var _app = require('./components/app');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function requireAll(requireContext) {
    var pages = {};
    requireContext.keys().forEach(function (file) {
        pages[file] = requireContext(file);
    });
    return pages;
}
function start(_ref) {
    var title = _ref.title,
        pages = _ref.pages,
        apiDocs = _ref.apiDocs;

    if (pages) {
        pages = requireAll(pages);
    }
    function renderApp(App) {
        var root = document.getElementById('app');
        (0, _reactDom.render)(React.createElement(App, { title: title, pages: pages, apiDocs: apiDocs }), root);
    }
    if (window.document) {
        renderApp(_app.App);
    }
    if (module['hot']) {
        module['hot'].accept('./components/app', function () {
            var UpdatedApp = require('./components/app').App;
            setTimeout(function () {
                return renderApp(UpdatedApp);
            });
        });
    }
}
document.addEventListener('mouseup', function (event) {
    var target = event.target;
    while (target && target.tagName && target.tagName.toLowerCase() !== 'a') {
        target = target.parentElement;
    }
    if (target && target.tagName) {
        target.blur();
    }
});
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ../documittu/packages/template/dist/index.js